import { createSelector } from "reselect";

import NylasStatus from "@app/enum/NylasStatus";

import { RootState } from "../rootReducer";

const nylasState = (state: RootState) => state.nylas;
export const isInitializing = createSelector(nylasState, ({ initializing }) => initializing);
export const getNylasCalendarInfo = createSelector(
  nylasState,
  ({ nylasCalendarInfo }) => nylasCalendarInfo
);
export const getEmailNylasInfo = createSelector(nylasState, ({ nylasEmailInfo }) => nylasEmailInfo);

export const isNylasConnected = createSelector(
  getEmailNylasInfo,
  (nylasEmailInfo) => !!nylasEmailInfo
);

export const isNylasConnectionFailed = createSelector(
  getEmailNylasInfo,
  (nylasEmailInfo) =>
    !!nylasEmailInfo &&
    [null, NylasStatus.INVALID, NylasStatus.STOPPED, NylasStatus.SYNC_ERROR].includes(
      nylasEmailInfo.status ?? null
    )
);

export const isNylasConnectionActive = createSelector(
  isNylasConnected,
  isNylasConnectionFailed,
  (nylasConnected, nylasConnectionFailed) => nylasConnected && !nylasConnectionFailed
);

export const getCalendars = createSelector(nylasState, ({ calendars }) => calendars);
export const areCalendarsLoading = createSelector(
  nylasState,
  ({ calendarsLoading }) => calendarsLoading
);

export const isCreatingCalendarEventForDealClosingDate = createSelector(
  nylasState,
  ({ createCalendarEventForDealClosingDateLoading }) => createCalendarEventForDealClosingDateLoading
);

export const isNylasCreating = createSelector(nylasState, ({ creating }) => creating);

export const isNylasUpdating = createSelector(nylasState, ({ updating }) => updating);

export const isNylasDeleting = createSelector(nylasState, ({ deleting }) => deleting);

export const isNylasCalendarSetupFinished = createSelector(
  nylasState,
  ({ nylasCalendarInfo }) => !!nylasCalendarInfo?.calendarId
);
